import { createAction } from 'redux-actions';
import {
  ACTION_REQUIRED_MESSAGES_REQUEST,
  ACTION_REQUIRED_MESSAGES_SUCCESS,
  ACTION_REQUIRED_MESSAGES_FAILURE,
  HISTORY_REQUEST,
  HISTORY_SUCCESS,
  HISTORY_FAILURE,
  DISMISS_REQUEST,
  DISMISS_SUCCESS,
  DISMISS_FAILURE,
  DISMISS_ALL_REQUEST,
  DISMISS_ALL_SUCCESS,
  DISMISS_ALL_FAILURE,
  GET_HISTORY_DATA_NEXT_REQUEST,
  GET_HISTORY_DATA_NEXT_SUCCESS,
  GET_HISTORY_DATA_NEXT_FAILURE,
  SET_FAST_POLLING_REQUEST,
  SET_SLOW_POLLING_REQUEST,
  START_POLLING,
  ACTION_REQUIRED_COUNT_REQUEST,
  ACTION_REQUIRED_COUNT_SUCCESS,
  ACTION_REQUIRED_COUNT_FAILURE,
  ACTION_UPDATED_MESSAGES_REQUEST,
  ACTION_UPDATED_MESSAGES_SUCCESS,
  ACTION_UPDATED_MESSAGES_FAILURE,
  DELETE_MESSAGES,
} from './message-center-constants';

export const fetchActionRequiredMessages = createAction(ACTION_REQUIRED_MESSAGES_REQUEST);
export const actionRequiredMessagesSuccess = createAction(ACTION_REQUIRED_MESSAGES_SUCCESS);
export const actionRequiredMessagesFailure = createAction(ACTION_REQUIRED_MESSAGES_FAILURE);

export const fetchActionRequiredCount = createAction(ACTION_REQUIRED_COUNT_REQUEST);
export const actionRequiredCountSuccess = createAction(ACTION_REQUIRED_COUNT_SUCCESS);
export const actionRequiredCountFailure = createAction(ACTION_REQUIRED_COUNT_FAILURE);

export const fetchActionUpdatedMessages = createAction(ACTION_UPDATED_MESSAGES_REQUEST);
export const actionUpdatedMessagesSuccess = createAction(ACTION_UPDATED_MESSAGES_SUCCESS);
export const actionUpdatedMessagesFailure = createAction(ACTION_UPDATED_MESSAGES_FAILURE);

export const deleteMessages = createAction(DELETE_MESSAGES);

export const fetchHistory = createAction(HISTORY_REQUEST);
export const historySuccess = createAction(HISTORY_SUCCESS);
export const historyFailure = createAction(HISTORY_FAILURE);

export const dismissMessage = createAction(DISMISS_REQUEST);
export const dismissSuccess = createAction(DISMISS_SUCCESS);
export const dismissFailure = createAction(DISMISS_FAILURE);

export const dismissAllMessages = createAction(DISMISS_ALL_REQUEST);
export const dismissAllSuccess = createAction(DISMISS_ALL_SUCCESS);
export const dismissAllFailure = createAction(DISMISS_ALL_FAILURE);

export const getHistoryDataNext = createAction(GET_HISTORY_DATA_NEXT_REQUEST);
export const getHistoryDataNextSuccess = createAction(GET_HISTORY_DATA_NEXT_SUCCESS);
export const getHistoryDataNextFailure = createAction(GET_HISTORY_DATA_NEXT_FAILURE);

export const setFastPollingRequest = createAction(SET_FAST_POLLING_REQUEST);
export const setSlowPollingRequest = createAction(SET_SLOW_POLLING_REQUEST);
export const startPolling = createAction(START_POLLING);
